import React from "react";
import ErrorBoundary from "src/components/errorboundary/errorboundary.v1";
import Module from "src/modules/separator";

const SliceComponent = (props: any) => {
  const { sliceContext } = props;
  return <>
  <ErrorBoundary fallback={null}>
    <Module data={{ selectedLanguage: sliceContext.language, item: sliceContext.item }} />
  </ErrorBoundary>
  </>
}

export default SliceComponent;